import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import * as serviceWorker from './serviceWorker';
import store from './stores/main';
import Router from './Router';
import './utils/datadog';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = createRoot(rootElement);
root.render(
	<Provider store={store as any}>
		<Router />
	</Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
